/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import Immutable from 'immutable';
import PropTypes from '../util/prop_types';
import { ViewSelectors } from '../stores/view_selectors';
import { ViewActionCreators } from '../stores/view_action_creators';
import MenuSection from './menu_section'

const mapStateToProps = (state) => {
  return {
    isMenuVisible: ViewSelectors.isMenuVisible(state),
    menuSettings: ViewSelectors.getMenuSettings(state),
  }
}

const mapDispatchToProps = {
  toggleMenu: ViewActionCreators.toggleMenu,
}

class Menu extends React.Component {
  static propTypes = {
    isMenuVisible: PropTypes.bool.isRequired,
    toggleMenu: PropTypes.func.isRequired,
  }

  _renderSections = () => {
    const { menuSettings } = this.props;

    if (menuSettings.count() > 0) {
      return menuSettings.get('sections').map(section => {
        return (
          <MenuSection
            key={section.get('key')}
            section={section} />
        );
      });
    }
  }

  render(): ?React.Element<any> {
    const { props, state } = this;
    const className = (props.isMenuVisible) ? "menu-open" : "";

    const sections = this._renderSections();

    return (
      <div id="menu-container"
        className={className}>
        <div id="menu-overlay"
          onClick={props.toggleMenu} />
        <div id="menu">
          <div id="menu-header">
            <h2>Menu</h2>
            <button
              id="menu-close"
              onClick={props.toggleMenu}>
              <FontAwesome
                name="angle-double-left"
                ariaLabel="Close" />
            </button>
          </div>
          <div id="menu-content">
            {sections}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
